import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTooltip } from '@angular/material/tooltip';
import { MatDialog } from '@angular/material/dialog';
import { ButtonPadraoComponent } from '../../shared/components/button-padrao/button-padrao.component';
import { TabelaSkeletonComponent } from '../../shared/components/tabela-skeleton/tabela-skeleton.component';
import { CustoMensagemWhatsapp } from '../../shared/model/parametros/custo-mensagem-whatsapp.model';
import { CustoMensagemWhatsappService } from '../../shared/service/custo-mensagem-whatsapp.service';
import { MsgService } from '../../shared/service/msg.service';
import { ModalCadastroCustoWhatsappComponent } from './modal-cadastro-custo-whatsapp/modal-cadastro-custo-whatsapp.component';

@Component({
  selector: 'app-card-whatsapp',
  standalone: true,
  imports: [CommonModule, MatTableModule, MatTooltip, ButtonPadraoComponent, TabelaSkeletonComponent],
  templateUrl: './card-whatsapp.component.html',
  styleUrl: './card-whatsapp.component.css'
})
export class CardWhatsappComponent implements OnInit {
  private readonly custoService = inject(CustoMensagemWhatsappService);
  private readonly msgService = inject(MsgService);
  private readonly dialog = inject(MatDialog);
  private readonly destroyRef = inject(DestroyRef);

  custos: CustoMensagemWhatsapp[] = [];
  dataSource = new MatTableDataSource<CustoMensagemWhatsapp>();
  carregando = true;

  displayedColumns: string[] = ['acao', 'pais', 'categoria', 'custo', 'criadoPor', 'alteradoPor'];

  readonly opcoesPais = [
    { id: 'BR', nome: 'Brasil' },
    { id: 'US', nome: 'Estados Unidos' },
    { id: 'AR', nome: 'Argentina' },
    { id: 'CL', nome: 'Chile' },
    { id: 'MX', nome: 'México' }
  ];

  readonly opcoesCategoria = [
    { id: 'MARKETING', nome: 'Marketing' },
    { id: 'UTILITY', nome: 'Utilidade' },
    { id: 'AUTHENTICATION', nome: 'Autenticação' },
    { id: 'SERVICE', nome: 'Serviço' }
  ];

  ngOnInit(): void {
    this.buscarCustos();
  }

  buscarCustos(): void {
    this.carregando = true;
    this.custoService.listar()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: res => {
          this.custos = res ?? [];
          this.dataSource = new MatTableDataSource(this.custos);
          this.carregando = false;
        },
        error: () => {
          this.carregando = false;
          this.msgService.msgErro('Erro ao buscar os custos de mensagem WhatsApp');
        }
      });
  }

  nomePais(codigo: string): string {
    return this.opcoesPais.find(opcao => opcao.id === codigo)?.nome ?? codigo;
  }

  nomeCategoria(codigo: string): string {
    return this.opcoesCategoria.find(opcao => opcao.id === codigo)?.nome ?? codigo;
  }

  abrirModal(custo?: CustoMensagemWhatsapp): void {
    const dialogRef = this.dialog.open(ModalCadastroCustoWhatsappComponent, {
      width: '400px', height: '100vh',
      position: { top: '0', right: '0' },
      data: { custo: custo ? { ...custo } : undefined },
      panelClass: 'slide-modal'
    });

    dialogRef.afterClosed().subscribe({
      next: res => {
        if (!res) return;

        const custoRetornado: CustoMensagemWhatsapp = res.custo;
        const acao = custoRetornado.id
          ? this.custoService.atualizar(custoRetornado.id, custoRetornado)
          : this.custoService.salvar(custoRetornado);

        acao.subscribe({
          next: () => {
            this.msgService.msgSucesso('Custo de mensagem WhatsApp ' + (custoRetornado.id ? 'atualizado' : 'salvo') + ' com sucesso.');
            this.buscarCustos();
          },
          error: erro => this.msgService.msgErro(
            erro?.error?.detalhe ?? 'Erro ao salvar o custo de mensagem WhatsApp'
          )
        });
      }
    });
  }
}
